import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ClientTransformation {
  id: number;
  beforeImage?: string;
  afterImage: string;
  testimonial: string;
  testimonialShort?: string;
  planName: string;
}
export const ClientTransformationShowcase: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const transformations: ClientTransformation[] = [{
    id: 3,
    beforeImage: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/IMG_9933_2.jpg',
    afterImage: 'https://cdn.magicpatterns.com/uploads/3wwHV1mHRu4YoWB92ofmE6/Screenshot_2025-12-27_at_20.25.37.png',
    testimonial: 'Vyzkoušel jsem už několik různých tréninkových plánů, ale hned jak jsem poprvé zkusil tenhle, věděl jsem, že je to přesně ono. Už od začátku se mi podle něj cvičilo fakt dobře a všechno dávalo smysl. Největší rozdíl ale vidím ve výsledcích, kterých jsem za tři měsíce dosáhl. Kdybych měl tenhle plán někomu doporučit, tak bez váhání řeknu, ať ho zkusí. Jsem si jistý, že to spoustě lidem opravdu pomůže.',
    planName: '3 měsíční plán (pokročilý)'
  }, {
    id: 1,
    beforeImage: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_UfvYMToM_864x1152_1766861258705.webp',
    afterImage: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_UgQvynrt_800x1264_1766948855818.webp',
    testimonialShort: 'Po delší době jsem zase začal cvičit a upřímně jsem nevěděl, jestli mě to bude bavit a jestli vůbec uvidím nějaký výsledky, ale už po pár trénincích jsem cítil, že tenhle plán je úplně o něčem jiným ve srovnání s tím, jak jsem cvičíval dřív. Všechno je jasně vysvětlený technika, intenzita, pauzy, zapisovnání progressu.',
    testimonial: 'Po delší době jsem zase začal cvičit a upřímně jsem nevěděl, jestli mě to bude bavit a jestli vůbec uvidím nějaký výsledky, ale už po pár trénincích jsem cítil, že tenhle plán je úplně o něčem jiným ve srovnání s tím, jak jsem cvičíval dřív. Všechno je jasně vysvětlený technika, intenzita, pauzy, zapisovnání progressu. Já jsem si vybral rovnou 3 měsíční plán, a jsem rád, že jsem tak udělal, jelikož první měsíc si člověk zvyká na všechn, ale ty hlavní změny, a pochopení toho, jak správně cvičit si myslím, že přišlo kolem 2 měsíce. Abych to shrnul po 3 měsících moje síla šla nahoru, začal jsem mít lepší pumpu, a konečně jsem měl pocit, že se někam fakt posouvám. Tenhle plán bych doporučil každému, ať už někdo začíná úplně od nuly nebo někomu kdo má zkušenosti, ale nemá progres a neví proč. A hlavně bych chtěl poukázat na jednu věc pro lidi, kteří se rozhodují mezi tímhle plánem nebo jiným. Vemte v potaz tuhle myšlenku : většina trenérů a online plánů nechce, aby ses naučil cvičit samostatně, protože jejich byznys je postavený na tom, že budeš platit dlouhodbě, proto ti často dávají tréninky tak složitý, že ani nevíš proč to vlastně děláš. Tenhle plán je úplný opak, je jednoduchý v tom správným slova smyslu, má jasný systém, a je udělaný, tak že opravdu každý by měl v průběhu plánu pochopit jak cvičit, a hlavně získat progress. Nejlepší na tom je, že tady zaplatíš jednou a už nic neřešíš. Dostaneš návod na správné cvičení, který ti jinde tak snadno nedají, protože jakmile ho máš, tak už je nepotřebuješ, a přesně protože mi tenhle plán dává opravdu smysl, tak k němu píšu takovou recenzi.',
    planName: '3 měsíční plán (pokročilý)'
  }, {
    id: 2,
    beforeImage: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_7A0OcnL3_800x1248_1766860727661.webp',
    afterImage: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/openart-image_h8HK1UaO_976x1024_1766861040822.webp',
    testimonial: 'Tento treninkovy plan me naucil jak se lepe posouvat ve cviceni a odbourat dlouhodobe stagnace. Zjistil jsem spravne techniky cviceni, intenzitu, progresive overload a dopodrovna vysvetlene postupy cviceni. Díky treninkovemu planu me cviceni zacalo daleko vice bavit protoze jsem take zacal videt vetsi progres.',
    planName: '3 měsíční plán (začátečník)'
  }];
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % transformations.length);
    setIsExpanded(false);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + transformations.length) % transformations.length);
    setIsExpanded(false);
  };
  const currentTransformation = transformations[currentIndex];
  // Determine which text to show
  const hasExpandableText = currentTransformation.testimonialShort !== undefined;
  const displayText = hasExpandableText && !isExpanded ? currentTransformation.testimonialShort : currentTransformation.testimonial;
  return <section className="relative py-8 md:py-16 bg-gradient-to-b from-transparent via-gray-900/30 to-transparent" data-id="element-244">
      {/* Elegant top separator */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500/20 to-transparent" data-id="element-245" />

      {/* Subtle glow effect at top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-32 bg-green-500/5 blur-3xl pointer-events-none" data-id="element-246" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-247">
        {/* Section Header - More Compact on Mobile */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-4 md:mb-12" data-id="element-248">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} viewport={{
          once: true
        }} className="inline-block mb-2" data-id="element-249">
            <span className="text-green-500/80 font-bold tracking-[0.15em] uppercase text-[10px] md:text-xs" data-id="element-250">
              Skutečné výsledky
            </span>
          </motion.div>

          <h2 className="text-xl md:text-4xl font-black text-white mb-2 leading-tight px-2" data-id="element-251">
            Výsledky klientů, kteří dali{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-500" data-id="element-252">
              souhlas se zveřejněním
            </span>
          </h2>
        </motion.div>

        {/* Transformation Carousel - Optimized for Mobile */}
        <div className="max-w-5xl mx-auto" data-id="element-253">
          <div className="relative" data-id="element-254">
            {/* Navigation Buttons - Mobile: between images, Desktop: outside */}
            <button onClick={prevSlide} className="absolute left-0 md:-left-12 top-[240px] md:top-[225px] -translate-y-1/2 z-20 bg-gray-900/80 hover:bg-green-600/90 border border-gray-700/50 hover:border-green-500/50 rounded-full p-2 md:p-3 transition-all duration-300 backdrop-blur-sm group shadow-lg" aria-label="Previous transformation" data-id="element-255">
              <ChevronLeftIcon className="w-4 h-4 md:w-6 md:h-6 text-gray-400 group-hover:text-white transition-colors" data-id="element-256" />
            </button>

            <button onClick={nextSlide} className="absolute right-0 md:-right-12 top-[240px] md:top-[225px] -translate-y-1/2 z-20 bg-gray-900/80 hover:bg-green-600/90 border border-gray-700/50 hover:border-green-500/50 rounded-full p-2 md:p-3 transition-all duration-300 backdrop-blur-sm group shadow-lg" aria-label="Next transformation" data-id="element-257">
              <ChevronRightIcon className="w-4 h-4 md:w-6 md:h-6 text-gray-400 group-hover:text-white transition-colors" data-id="element-258" />
            </button>

            {/* Transformation Content */}
            <AnimatePresence mode="wait" data-id="element-259">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 100
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -100
            }} transition={{
              duration: 0.5,
              ease: 'easeInOut'
            }} className="bg-gray-900/40 backdrop-blur-sm rounded-xl border border-gray-700/30 overflow-hidden shadow-2xl" data-id="element-260">
                <div className="absolute inset-0 bg-gradient-to-b from-green-500/5 to-transparent pointer-events-none rounded-xl" data-id="element-261" />

                <div className={`grid ${currentTransformation.beforeImage ? 'md:grid-cols-2' : 'md:grid-cols-1'} gap-0 relative`} data-id="element-262">
                  {/* Before Image - Only show if exists */}
                  {currentTransformation.beforeImage && <div className="relative" data-id="element-263">
                      <div className="relative h-[240px] md:h-[450px] overflow-hidden group" data-id="element-264">
                        <img src={currentTransformation.beforeImage} alt="Before transformation" className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${currentTransformation.id === 1 ? 'object-[center_35%] md:object-[center_30%]' : 'object-[center_20%] md:object-center'}`} data-id="element-265" />

                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" data-id="element-266" />
                        <div className="absolute bottom-2 left-2 md:bottom-3 md:left-3 bg-red-600/80 backdrop-blur-sm px-2 py-1 md:px-3 md:py-1.5 rounded-md border border-red-500/20" data-id="element-267">
                          <span className="text-white font-bold text-[10px] md:text-sm tracking-wide" data-id="element-268">
                            PŘED
                          </span>
                        </div>
                      </div>
                    </div>}

                  {/* After Image */}
                  <div className="relative" data-id="element-269">
                    <div className="relative h-[240px] md:h-[450px] overflow-hidden group" data-id="element-270">
                      <img src={currentTransformation.afterImage} alt="After transformation" className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" data-id="element-271" />

                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" data-id="element-272" />
                      <div className="absolute bottom-2 right-2 md:bottom-3 md:right-3 bg-green-600/80 backdrop-blur-sm px-2 py-1 md:px-3 md:py-1.5 rounded-md border border-green-500/20" data-id="element-273">
                        <span className="text-white font-bold text-[10px] md:text-sm tracking-wide" data-id="element-274">
                          PO
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Testimonial - More Compact on Mobile */}
                <div className="p-3 md:p-7 border-t border-gray-700/30 bg-gray-900/20 relative" data-id="element-275">
                  {/* Plan Name Badge - Elegant & Luxurious */}
                  <div className="flex justify-center mb-3 md:mb-4" data-id="element-276">
                    <div className="relative inline-flex items-center" data-id="element-277">
                      {/* Glow effect behind badge */}
                      <div className="absolute inset-0 bg-green-500/20 blur-md rounded-full" data-id="element-278"></div>

                      <div className="relative bg-gradient-to-r from-green-500/10 via-green-500/20 to-green-500/10 backdrop-blur-sm border border-green-500/30 px-3 py-1.5 md:px-4 md:py-2 rounded-full" data-id="element-279">
                        <span className="text-green-400 font-bold text-[10px] md:text-xs tracking-wider uppercase" data-id="element-280">
                          {currentTransformation.planName}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="relative" data-id="element-281">
                    {/* Quote icon - smaller on mobile */}
                    <div className="absolute -top-1 -left-1 text-green-500/10 text-3xl md:text-5xl font-serif leading-none" data-id="element-282">
                      "
                    </div>

                    <p className="text-gray-300 text-[10px] md:text-sm leading-relaxed italic relative z-10 pl-4 md:pl-5 inline" data-id="element-283">
                      {displayText}
                      {/* Inline "více..." or "méně..." button */}
                      {hasExpandableText && <button onClick={() => setIsExpanded(!isExpanded)} className="text-green-400 hover:text-green-300 text-[10px] md:text-sm font-semibold transition-colors duration-200 ml-1 inline" data-id="element-284">
                          {isExpanded ? 'méně...' : 'více...'}
                        </button>}
                    </p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Progress Indicators - More Subtle */}
            <div className="flex justify-center gap-2 mt-4 md:mt-6" data-id="element-285">
              {transformations.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-1.5 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-6 bg-green-500/80' : 'w-1.5 bg-gray-700 hover:bg-gray-600'}`} aria-label={`Go to transformation ${index + 1}`} data-id="element-286" />)}
            </div>
          </div>
        </div>
      </div>

      {/* Elegant bottom separator */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500/20 to-transparent" data-id="element-287" />

      {/* Subtle glow effect at bottom */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/2 h-32 bg-green-500/5 blur-3xl pointer-events-none" data-id="element-288" />
    </section>;
};